export default {"src":"/_next/static/media/HeroImage.f606cd04.svg","height":700,"width":965,"blurWidth":0,"blurHeight":0};